import { render } from "./FollowUpTask.vue?vue&type=template&id=626ca4af"
import script from "./FollowUpTask.vue?vue&type=script&lang=js"
export * from "./FollowUpTask.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__